import angular from "angular"
import { defaultWeight, weightFunctions, fullWeightFunctions } from "../counter-label"

angular.module("uCountitUiApp").controller("weightInputCtrl", ($scope) => {
  if (!$scope.weight) $scope.weight = defaultWeight
  if (!$scope.mode) $scope.mode = "normal"

  $scope.WFs = $scope.mode === "full" ? fullWeightFunctions : weightFunctions
  $scope.function = {
    list: $scope.WFs,
    selected: $scope.WFs.find((f) => f.function === $scope.weight.function) || $scope.WFs[0],
  }

  $scope.strParams = $scope.function.selected.paramsToString($scope.weight.params)

  $scope.$watch("function.selected", (newFunc, oldFunc) => {
    $scope.weight.function = newFunc.function
    if (newFunc.function !== oldFunc.function) $scope.strParams = newFunc.defaultStrParams
  })

  $scope.$watch("strParams", (strParams) => {
    $scope.weight.params = $scope.function.selected.stringToParams(strParams)
  })
})
